import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import UploaderAddBase from './UploaderAddBase';

import { isValidLink } from '../utils/link.utils';

const UploaderAdd3DTour = ({ onBack, onDone, onAdd, onDelete, media, isAdding }) => {
  return (
    <UploaderAddBase
      title={<FormattedMessage id="uploader.three_d_tour_modal.title" defaultMessage="Add 3D tour" />}
      description={
        <>
          <FormattedMessage id="uploader.three_d_tour_modal.description" defaultMessage="Use Matterport to give guests a 3D walk through to visualize your space." />
          {' '}
          <a href="https://support.peerspace.com/en/articles/12688568-video-and-tour-tips-and-requirements" target="_blank" rel="noopener noreferrer" className='add-3d-link tw-text-gray-600'><FormattedMessage id="uploader.three_d_tour_modal.description_link" defaultMessage="Learn more" /></a>
          {' '}
          <FormattedMessage id="uploader.embed.wait" defaultMessage="It may take up to 48 hours for your content to appear on your listings." />
        </>
      }
      linkTitle={<FormattedMessage id="uploader.three_d_tour_modal.link_title" defaultMessage="Matterport link" />}
      linkDescription={<FormattedMessage id="uploader.three_d_tour_modal.link_description" defaultMessage="We accept Matterport links only." />}
      alert={<FormattedMessage id="uploader.three_d_tour_modal.alert" defaultMessage="3D tours appear in your listing gallery, and clear labels will show in search results and on your listing page so guests know a virtual tour is available." />}
      onBack={onBack}
      onDone={onDone}
      onAdd={onAdd}
      onDelete={onDelete}
      onValidation={(link) => isValidLink(link, '3d')}
      media={media}
      isAdding={isAdding}
    />
  );
};

UploaderAdd3DTour.propTypes = {
  onBack: PropTypes.func,
  onDone: PropTypes.func,
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  media: PropTypes.array,
  isAdding: PropTypes.bool
};

UploaderAdd3DTour.defaultProps = {
  onBack: () => {},
  onDone: () => {},
  onAdd: () => {},
  onDelete: () => {},
  media: [],
  isAdding: false
};

export default UploaderAdd3DTour;
